const PAGE_TITLE = "Serviços Digitais Omint para Associados";
const PAGE_DESCRIPTION =
  "Conheça os serviços digitais Omint para associados: App Omint, Site Omint, WhatsApp, credencial digital, busca de rede, reembolso, autorizações, teleatendimento e gestão de acesso.";
const LOGO_URL = "https://omint.app.br/images/omint/logo-omint-app.png";
const FONT_STYLESHEET_URL =
  "https://fonts.googleapis.com/css2?family=Source+Serif+4:opsz,wght@8..60,500;8..60,700&family=Work+Sans:wght@400;500;600;700&display=swap";
const ORGANIZATION_URL = "https://www.omint.com.br/";
const ORGANIZATION_DESCRIPTION =
  "A Omint oferece serviços de saúde, odontologia, seguro viagem, seguro de vida e clínica odontológica no Brasil.";
const ORGANIZATION_SAME_AS = [
  "https://www.facebook.com/omint",
  "https://www.instagram.com/omint/",
  "https://www.youtube.com/omint",
  "https://www.linkedin.com/company/omint/",
  "https://open.spotify.com/user/omint"
];
const ORGANIZATION_ADDRESS = {
  "@type": "PostalAddress",
  streetAddress: "Rua Franz Schubert, 33, Jardim Paulistano",
  addressLocality: "São Paulo",
  addressRegion: "SP",
  postalCode: "01454-020",
  addressCountry: "BR"
};
const ORGANIZATION_CONTACT_POINTS = [
  {
    "@type": "ContactPoint",
    contactType: "Atendimento Omint",
    telephone: "+55-800-726-4000",
    email: "faleconosco@omint.com.br",
    areaServed: "BR"
  },
  {
    "@type": "ContactPoint",
    contactType: "WhatsApp Omint",
    telephone: "+55-11-99935-1140",
    areaServed: "BR"
  }
];

const SERVICE_ITEMS = [
  {
    name: "App Omint",
    description: "Acessar serviços do plano pelo celular",
    benefit: "Autonomia e praticidade"
  },
  {
    name: "Site Omint",
    description: "Utilizar serviços digitais pela web",
    benefit: "Conveniência e navegação ampliada"
  },
  {
    name: "WhatsApp Omint",
    description: "Receber alertas e acessar serviços pelo WhatsApp",
    benefit: "Proximidade e agilidade"
  },
  {
    name: "Credencial digital e token",
    description: "Apresentar identificação na rede credenciada",
    benefit: "Segurança no atendimento"
  },
  {
    name: "Busca de rede",
    description: "Encontrar médicos, clínicas e hospitais",
    benefit: "Facilidade para escolher prestadores"
  },
  {
    name: "Busca com IA",
    description: "Pesquisar rede por texto, voz ou imagem de pedido médico",
    benefit: "Mais rapidez e orientação"
  },
  {
    name: "Reembolso digital",
    description: "Solicitar e acompanhar reembolsos",
    benefit: "Menos burocracia e mais transparência"
  },
  {
    name: "Autorizações",
    description: "Solicitar e acompanhar autorizações prévias",
    benefit: "Previsibilidade do processo"
  },
  {
    name: "Teleatendimento",
    description: "Agendar e realizar consultas digitais",
    benefit: "Acesso ao cuidado sem deslocamento"
  },
  {
    name: "Programas de saúde",
    description: "Interagir com equipes de programas de cuidado",
    benefit: "Continuidade e acompanhamento"
  },
  {
    name: "Coparticipação",
    description: "Simular e consultar valores e extratos",
    benefit: "Controle financeiro"
  },
  {
    name: "Gestão de acesso",
    description: "Definir permissões para familiares e terceiros",
    benefit: "Privacidade e personalização"
  },
  {
    name: "Acessibilidade",
    description: "Usar recursos como Libras e ajustes de navegação",
    benefit: "Inclusão e autonomia"
  },
  {
    name: "Documentos digitais",
    description: "Consultar manuais, informes, faturas e cartas",
    benefit: "Acesso rápido a informações importantes"
  }
];

const FAQ_ITEMS = [
  {
    question: "O que são os serviços digitais Omint?",
    answer:
      "São os canais e funcionalidades digitais disponíveis para associados Omint pelo App, Site e WhatsApp. Eles permitem acessar serviços do plano, iniciar solicitações, acompanhar protocolos, receber alertas e consultar informações de forma segura e integrada."
  },
  {
    question: "Quais canais digitais a Omint oferece aos associados?",
    answer:
      "A Omint oferece serviços digitais pelo App Omint, Site Omint e WhatsApp Omint. Esses canais são integrados e permitem que o associado acompanhe sua jornada de forma mais simples e conveniente."
  },
  {
    question: "Posso usar o mesmo login no App, Site e WhatsApp Omint?",
    answer:
      "Sim. Os canais digitais Omint utilizam login único, oferecendo mais praticidade e segurança no acesso aos serviços."
  },
  {
    question: "O App Omint tem carteirinha digital?",
    answer:
      "Sim. O App Omint disponibiliza credencial digital e token de atendimento, inclusive para pessoas do grupo familiar e produtos contratados, conforme elegibilidade."
  },
  {
    question: "A credencial digital funciona sem internet?",
    answer:
      "O App Omint pode exibir a credencial digital e o token mesmo quando não houver conexão com a internet, facilitando o atendimento na rede credenciada."
  },
  {
    question: "Como encontro médicos e clínicas da rede credenciada Omint?",
    answer:
      "A busca de rede pode ser feita pelo App ou Site Omint. O associado pode pesquisar por especialidade, nome, localização, distância, facilidades, idioma, teleconsulta, agendamento online e outros filtros disponíveis."
  },
  {
    question: "A Omint oferece busca de rede com Inteligência Artificial?",
    answer:
      "Sim. A Omint oferece busca de rede com apoio de Inteligência Artificial. O associado pode escrever, falar ou enviar a imagem de um pedido médico para receber apoio na localização de serviços e profissionais relacionados à sua necessidade."
  },
  {
    question: "Posso solicitar reembolso pelo App Omint?",
    answer:
      "Sim. O associado pode solicitar reembolso pelos canais digitais, enviar documentos, acompanhar o andamento e consultar detalhes da análise e do cálculo."
  },
  {
    question: "Posso acompanhar autorizações pelo App ou Site?",
    answer:
      "Sim. Autorizações prévias podem ser acompanhadas pelos canais digitais Omint, com visualização de status, detalhes da solicitação e histórico."
  },
  {
    question: "Como funciona o WhatsApp Omint?",
    answer:
      "O WhatsApp Omint permite receber alertas, acompanhar solicitações, acessar serviços digitais e contar com atendimento apoiado por Inteligência Artificial e atendimento humano quando necessário."
  },
  {
    question: "A Omint oferece teleconsulta?",
    answer:
      "Sim. Pelo Dr. Omint, o associado pode agendar e realizar consultas por teleatendimento, conforme disponibilidade do serviço e condições do plano."
  },
  {
    question: "Posso compartilhar minhas informações com familiares?",
    answer:
      "Sim. A Omint permite que o próprio associado defina quais informações deseja compartilhar com pessoas do grupo familiar ou terceiros autorizados, preservando a privacidade e o controle sobre seus dados."
  },
  {
    question: "A Omint protege minhas informações pessoais e de saúde?",
    answer:
      "Sim. A experiência digital Omint utiliza login individual, validações de identidade, biometria facial, gestão de permissões, rastreabilidade e acesso restrito às informações pessoais, médicas e financeiras."
  },
  {
    question: "O atendimento humano continua disponível?",
    answer:
      "Sim. Os canais digitais facilitam a jornada, mas a equipe de Atendimento e Concierge Omint continua disponível para apoiar o associado em dúvidas, orientações e situações que exigem cuidado humano."
  }
];

function getPageUrl() {
  return window.location.href.split(/[?#]/)[0].replace(/\/$/, "");
}

export function getDigitalServicesStructuredData(pageUrl) {
  const organizationId = ORGANIZATION_URL + "#organization";
  const webpageId = pageUrl + "#webpage";
  const serviceId = pageUrl + "#digital-services";

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": organizationId,
        name: "Omint",
        alternateName: "Grupo Omint",
        legalName: "Omint Serviços de Saúde S.A.",
        url: ORGANIZATION_URL,
        description: ORGANIZATION_DESCRIPTION,
        logo: {
          "@type": "ImageObject",
          url: LOGO_URL
        },
        foundingDate: "1980-10-28",
        foundingLocation: {
          "@type": "Place",
          name: "Brasil"
        },
        founder: {
          "@type": "Person",
          name: "Juan Carlos Villa Larroudet"
        },
        address: ORGANIZATION_ADDRESS,
        email: "faleconosco@omint.com.br",
        telephone: "+55-800-726-4000",
        taxID: "44.673.382/0001-90",
        contactPoint: ORGANIZATION_CONTACT_POINTS,
        sameAs: ORGANIZATION_SAME_AS
      },
      {
        "@type": "WebPage",
        "@id": webpageId,
        url: pageUrl,
        name: PAGE_TITLE,
        description: PAGE_DESCRIPTION,
        inLanguage: "pt-BR",
        publisher: {
          "@id": organizationId
        },
        about: {
          "@id": serviceId
        }
      },
      {
        "@type": "Service",
        "@id": serviceId,
        name: "Serviços digitais Omint",
        serviceType: "Serviços digitais para associados de plano de saúde",
        description: PAGE_DESCRIPTION,
        provider: {
          "@id": organizationId
        },
        audience: {
          "@type": "Audience",
          audienceType: "Associados Omint"
        },
        areaServed: {
          "@type": "Country",
          name: "Brasil"
        },
        hasOfferCatalog: {
          "@type": "OfferCatalog",
          name: "Serviços digitais Omint",
          itemListElement: SERVICE_ITEMS.map(item => ({
            "@type": "Offer",
            name: item.name,
            description: item.benefit ? item.description + ". Benefício: " + item.benefit : item.description,
            offeredBy: {
              "@id": organizationId
            },
            itemOffered: {
              "@type": "Service",
              name: item.name,
              description: item.benefit ? item.description + ". Benefício: " + item.benefit : item.description,
              provider: {
                "@id": organizationId
              },
              areaServed: {
                "@type": "Country",
                name: "Brasil"
              }
            }
          }))
        },
        mainEntityOfPage: {
          "@id": webpageId
        }
      },
      {
        "@type": "FAQPage",
        "@id": pageUrl + "#faq",
        mainEntity: FAQ_ITEMS.map(item => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.answer
          }
        }))
      }
    ]
  };
}

export function getDigitalServicesMeta(pageUrl) {
  return {
    title: PAGE_TITLE,
    htmlAttrs: {
      lang: "pt-BR"
    },
    meta: [
      {
        vmid: "description",
        name: "description",
        content: PAGE_DESCRIPTION
      },
      {
        vmid: "robots",
        name: "robots",
        content: "index, follow"
      },
      {
        vmid: "og:type",
        property: "og:type",
        content: "website"
      },
      {
        vmid: "og:title",
        property: "og:title",
        content: PAGE_TITLE
      },
      {
        vmid: "og:description",
        property: "og:description",
        content: PAGE_DESCRIPTION
      },
      {
        vmid: "og:url",
        property: "og:url",
        content: pageUrl
      },
      {
        vmid: "twitter:card",
        name: "twitter:card",
        content: "summary"
      },
      {
        vmid: "twitter:title",
        name: "twitter:title",
        content: PAGE_TITLE
      },
      {
        vmid: "twitter:description",
        name: "twitter:description",
        content: PAGE_DESCRIPTION
      }
    ],
    link: [
      {
        vmid: "preconnect-google-fonts",
        rel: "preconnect",
        href: "https://fonts.googleapis.com"
      },
      {
        vmid: "preconnect-google-fonts-static",
        rel: "preconnect",
        href: "https://fonts.gstatic.com",
        crossorigin: ""
      },
      {
        vmid: "digital-services-fonts",
        rel: "stylesheet",
        href: FONT_STYLESHEET_URL
      },
      {
        vmid: "canonical",
        rel: "canonical",
        href: pageUrl
      }
    ],
    script: [
      {
        vmid: "digital-services-structured-data",
        type: "application/ld+json",
        json: getDigitalServicesStructuredData(pageUrl)
      }
    ]
  };
}

export default {
  metaInfo() {
    return getDigitalServicesMeta(getPageUrl());
  }
};
